/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from "react";
import { useAuth } from "../Providers/Auth";
import { DashboardSkeleton } from "@/Components/Loader/dashboardSkeleton";
import { Button } from "@/shadcnComponents/ui/button";

const Check: React.FC = () => {
  const params = new URLSearchParams(window.location.search);
  const authState = useAuth();
  const [openRefresh, setOpenRefresh] = useState(false);

  // Use a ref to track if the effect has run
  const effectRan = useRef(false);

  useEffect(() => {
    if (effectRan.current) return; // Prevent running twice

    if (localStorage.getItem("from")) {
      if (localStorage.getItem("from") === "google") {
        const loginUser = async () => {
          await authState?.getGoogleDatatoLogin();
        };

        loginUser();
      }
    }

    if (params.get("token")) {
      const login = async () => {
        const res = await authState?.getLinkedinDatatoLogin(
          params.get("token") ?? ""
        );
        if (res?.refresh) {
          setOpenRefresh(true);
          console.log("Error while logging in");
          return;
        }
      };
      login();
    }

    effectRan.current = true;
  }, []);

  const handlerefresh = async () => {
    setOpenRefresh(false);
    window.location.reload();
  };

  return (
    <>
      {openRefresh && (
        <div className="w-screen h-screen fixed top-0 left-0 z-40 flex items-center justify-center bg-[#12121280]">
          <div className="flex flex-col p-5 gap-5 items-center justify-center text-center w-[400px] bg-[#F5F5F5] rounded-lg font-inter text-[#757575] text-[16px]">
            <p>
              <b>Login takes longer than usual</b>
            </p>
            <Button onClick={handlerefresh}>Try again</Button>
          </div>
        </div>
      )}
      <DashboardSkeleton />
    </>
  );
};

export default Check;
